import Bullet, { BulletProps } from '../Bullet/index.js';

export interface BulletListProps {
  list: (BulletProps & { key: string })[];
}

const BulletList = ({ list }: BulletListProps): JSX.Element => {
  return (
    <ul className="flex flex-col list-none gap-y-4">
      {list.map(({ key, ...rest }) => (
        <Bullet key={key} {...rest} />
      ))}
    </ul>
  );
};

export default BulletList;
